exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editorError{margin-top:70px;font-size:22px;text-align:center;line-height:1;top:0;bottom:0;left:0;right:0;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}.editorError .editorError-info{font-size:14px;margin-top:22px;line-height:28px}.editorError .editorError-defaultLiveSite-info{font-size:24px;font-weight:normal;height:72px;line-height:36px;text-align:center}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/widget/components/editorError/EditorError.scss
// module id = 518
// module chunks = 0 1